export default {
  Codigo: null,
  Descripcion: null,
  TipoCalculo: null,
  Activo: true,
};
